import * as React from "react";
import { Spinner, Link } from "components/common";
import Routes from "routing/Routes";
import useEventDefinition from "components/events/events/hooks/useEventDefinition";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
const EventDefinitionName = ({ eventDefinitionId, displayAsLink = true }) => {
  var _a;
  const currentUser = useCurrentUser();
  const canViewDefinition = isPermitted(currentUser.permissions, `eventdefinitions:read:${eventDefinitionId}`);
  const { data: eventDefinition, isFetching } = useEventDefinition(eventDefinitionId, canViewDefinition);
  const title = (_a = eventDefinition == null ? void 0 : eventDefinition.title) != null ? _a : eventDefinitionId;
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (!displayAsLink || !canViewDefinition) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
  }
  if (eventDefinition) {
    return /* @__PURE__ */ React.createElement(Link, { to: Routes.ALERTS.DEFINITIONS.show(eventDefinition.id), target: "_blank" }, title);
  }
  return null;
};
export default EventDefinitionName;
